var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isWechatBrowser)?_c('div',{staticClass:"wechat-mask"},[_vm._m(0)]):_vm._e(),(!_vm.isWechatBrowser)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wechat-tip"},[_c('i',{staticClass:"el-icon-warning-outline"}),_c('h3',[_vm._v("程序出错")]),_c('p',[_vm._v("普通浏览器打开")])])
}]

export { render, staticRenderFns }